<template>
  <div class="signboard">
    <div class="span"></div>
    <div class="span1">{{signboardName}}</div>
  </div>
</template>
<script>
export default {
  name: "signboard",
  props:{
    signboardName:{
      type:String,
      default:''
    }
  }

}
</script>

<style lang='less' scoped>
  .signboard {
    display: flex;
    height: 60px;
    align-items: center;
    .span {
      width: 4px;
      height: 16px;
      background: #008CFF;
      margin-left: 12px;
      margin-right: 16px;
    }
    .span1{
      height: 20px;
      font-size: 14px;
      font-weight: 600;
      color: #000000;
      line-height: 20px;
    }
  }
</style>